import React, { useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Box, CircularProgress } from '@mui/material'

import { loginUser, useAuthStorage } from '../../features/global'
import { PrivateRouter } from './private.router'
import { PublicRouter } from './public.router'
import { loadLocalStorage } from '../../core/utils'
import { NoticesPopupComponent } from '../../features/notices'

export const BootstrapRouter = () => {
  const dispatch = useDispatch()
  const user = loadLocalStorage('apins-auth')
  const { isSessionValid } = useAuthStorage()

  const { isAuthorized, role } = useSelector((state) => state.global)

  useEffect(() => {
    if (!isAuthorized && user?.token) dispatch(loginUser(user))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return useMemo(() => {
    if (isAuthorized && isSessionValid()) {
      if (!role) {
        return (
          <Box display="flex" height="100vh" justifyContent="center" alignItems="center">
            <CircularProgress size={40} />
          </Box>
        )
      }
      return <PrivateRouter />
    }
    return <PublicRouter />
  }, [isAuthorized, role, isSessionValid])
}
